/*
* @Author: babysoft08
* @Date:   2025-06-21 16:35:50
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-21 16:36:01
*/
import React, { useState, useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import './Tooltip.css';

const Tooltip = ({ message, children }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0, placeAbove: false });
  const iconRef = useRef();

  const updateCoords = useCallback(() => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      const placeAbove = rect.bottom + 150 > window.innerHeight && rect.top - 150 > 0;
      setCoords({
        top: placeAbove ? rect.top - 6 : rect.bottom + 6,
        left: rect.left + rect.width / 2,
        placeAbove,
      });
    }
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (
      iconRef.current &&
      !iconRef.current.contains(event.target) &&
      !event.target.closest('.tooltip-box')
    ) {
      setVisible(false);
    }
  }, []);

  const toggleVisible = (e) => {
    e.stopPropagation();
    if (!visible) {
      updateCoords();
    }
    setVisible(prev => !prev);
  };

  useEffect(() => {
    if (visible) {
      updateCoords();
      document.addEventListener('click', handleClickOutside);
      window.addEventListener('scroll', updateCoords, true);
      window.addEventListener('resize', updateCoords);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
      window.removeEventListener('scroll', updateCoords, true);
      window.removeEventListener('resize', updateCoords);
    };
  }, [visible, updateCoords, handleClickOutside]);

  return (
    <span className="tooltip-wrapper">
      <span ref={iconRef} onClick={toggleVisible} className="tooltip-icon">
        {children}
      </span>
      {visible &&
        ReactDOM.createPortal(
          <div
            className="tooltip-box"
            style={{
              position: 'fixed',
              top: `${coords.top}px`,
              left: `${coords.left}px`,
              transform: coords.placeAbove
                ? 'translate(-50%, -100%)'
                : 'translateX(-50%)',
            }}
          >
            {message}
          </div>,
          document.body
        )}
    </span>
  );
};

export default Tooltip;